var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"qr-code"},[_c('qrcodes',{attrs:{"id":"ysyqrocde","url":_vm.url,"iconurl":_vm.iconurl,"wid":_vm.wid,"hei":_vm.hei,"imgwid":_vm.imgwid,"imghei":_vm.imghei}}),_vm._v(" "),_c('div',{staticClass:"mask-code",on:{"click":_vm.saveQrcode}},[_c('span',[_vm._v("保存二维码")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8c5e1f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/QRcodeLogo.vue
// module id = null
// module chunks = 